import { render, staticRenderFns } from "./JobEndedTaskItemWrapper.vue?vue&type=template&id=0f34b90c&"
import script from "./JobEndedTaskItemWrapper.vue?vue&type=script&setup=true&lang=js&"
export * from "./JobEndedTaskItemWrapper.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports